import { attribute, create, clickable, collection, isPresent, text, visitable } from 'ember-cli-page-object';
export default create({
  visit: visitable('/private/registries'),
  emptyState: {
    scope: '[data-test-empty-state]'
  },
  create: clickable('[data-test-vagrant-registry-create]'),
  canCreate: isPresent('[data-test-vagrant-registry-create]'),
  registries: collection('[data-test-registries] tbody tr', {
    name: text('td:eq(0)'),
    created: text('td:eq(1)'),
    visit: clickable('td:eq(0) a')
  }),
  sidenav: {
    scope: '[data-test-sidebar-subnav-content]',
    // Visiting pages outside of the vagrant context will error, but we can still observe link generation
    dashboardHref: attribute('href', 'nav a:eq(0)'),
    gotoReclaim: clickable('nav a:eq(2)'),
    gotoDiscover: clickable('nav a:eq(3)')
  }
});